(() => {
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const PHONE = /^\+?[\d\s().-]{7,}$/;
  const NAME_KEY = 'inquiry-first-name';
  const DISMISS_KEY = 'floating-inquiry-dismissed';

  const storage = {
    get(key) {
      try { return sessionStorage.getItem(key); } catch (e) { return null; }
    },
    set(key, value) {
      try { sessionStorage.setItem(key, value); } catch (e) {}
    }
  };

  const firstName = (name) => name.trim().split(/\s+/)[0] || '';

  function initForm(form) {
    const done = form.querySelector('[data-inquiry-done]');
    if (done) {
      const name = storage.get(NAME_KEY);
      if (name) done.querySelector('[data-inquiry-thanks-name]').textContent = `, ${name}`;
      form.closest('#contact-form')?.scrollIntoView({ block: 'start' });
      done.focus({ preventScroll: true });
      return;
    }

    const steps = form.querySelectorAll('[data-inquiry-step]');
    const nameInput = form.querySelector('[data-inquiry-name]');
    const contactInput = form.querySelector('[data-inquiry-contact]');
    const nextButton = form.querySelector('[data-inquiry-next]');
    const submitButton = form.querySelector('[type="submit"]');
    const reach = form.querySelector('[data-inquiry-reach]');
    const error = form.querySelector('.inquiry-form__error[id]');
    const emailField = form.querySelector('[data-inquiry-email]');
    const phoneField = form.querySelector('[data-inquiry-phone]');

    const contactType = () => {
      const value = contactInput.value.trim();
      if (EMAIL.test(value)) return 'email';
      if (PHONE.test(value)) return 'phone';
      return null;
    };

    const showStep = (index) => {
      steps.forEach((step) => (step.hidden = step.dataset.inquiryStep !== String(index)));
      (index === 1 ? nameInput : contactInput).focus();
    };

    const setError = (on) => {
      error.hidden = !on;
      contactInput.classList.toggle('is-invalid', on);
      contactInput.setAttribute('aria-invalid', on);
    };

    const next = () => {
      const name = firstName(nameInput.value);
      if (!name) return;
      reach.textContent = reach.dataset.template.replace('[name]', name);
      showStep(2);
    };

    nameInput.addEventListener('input', () => {
      const valid = nameInput.value.trim() !== '';
      nextButton.disabled = !valid;
      nameInput.classList.toggle('is-valid', valid);
    });
    nameInput.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      next();
    });
    nextButton.addEventListener('click', next);
    form.querySelector('[data-inquiry-back]').addEventListener('click', () => showStep(1));

    contactInput.addEventListener('input', () => {
      const valid = contactType() !== null;
      submitButton.disabled = !valid;
      contactInput.classList.toggle('is-valid', valid);
      if (valid) setError(false);
    });
    contactInput.addEventListener('blur', () => {
      if (contactInput.value.trim()) setError(contactType() === null);
    });

    form.addEventListener('submit', (event) => {
      const type = contactType();
      if (!nameInput.value.trim()) {
        event.preventDefault();
        showStep(1);
        return;
      }
      if (!type) {
        event.preventDefault();
        setError(true);
        return;
      }
      const value = contactInput.value.trim();
      emailField.value = type === 'email' ? value : emailField.dataset.fallback;
      phoneField.disabled = type !== 'phone';
      phoneField.value = type === 'phone' ? value : '';
      storage.set(NAME_KEY, firstName(nameInput.value));
    });
  }

  function initFloating(floater) {
    const form = document.getElementById('contact-form');
    if (!form || storage.get(DISMISS_KEY)) return;

    const onScroll = () => {
      const viewport = window.innerHeight;
      floater.classList.toggle('is-past-hero', window.scrollY > viewport * 0.85);
      floater.classList.toggle('is-scrolled', window.scrollY > 80);
      floater.classList.toggle('is-form-near', form.getBoundingClientRect().top < viewport - 120);
    };

    onScroll();
    floater.hidden = false;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    floater.querySelector('[data-floating-inquiry-close]').addEventListener('click', () => {
      storage.set(DISMISS_KEY, '1');
      floater.hidden = true;
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    });
  }

  const init = (root) => {
    root.querySelectorAll('[data-inquiry-form]').forEach(initForm);
    root.querySelectorAll('[data-floating-inquiry]').forEach(initFloating);
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
